import { Nullable } from "@/api/ApiClient";

export type ProviderNoteFormData = Nullable<{
    id: string | undefined;
    sequence: string,
    document_key: string,
    numero: string,
    tipo: string,
    fecha: string,
    subtotal: number,
    impuestos: number,
    descuento: number,
    total: number,
    exchange_rate: number,
    providerInvoiceId: string,
    providerInvoice: any,
    currencyId: string,
    currency: any
}>;

export const ProviderNoteRelatedAttributes: Array<keyof ProviderNoteFormData> = ["currency", "providerInvoice"];